import React, { ReactNode } from 'react'
import { FetchBaseQueryError } from '@reduxjs/toolkit/query'
import { SerializedError } from '@reduxjs/toolkit'
import { isFetchBaseQueryError, isFetchBaseQueryHcError } from '@/utils/api.tsx'
import { Result } from 'antd'
import { ClassValue } from 'clsx'
import { cn } from '@/utils/style.ts'

type QueryErrorProps = {
  className?: ClassValue
  error?: FetchBaseQueryError | SerializedError
  children?: ReactNode
}

export const QueryErrorWrapper: React.FC<QueryErrorProps> = ({ error, children, ...rest }) => {
  if (!error) return children

  if (isFetchBaseQueryHcError(error)) {
    return <Error {...rest} title={error.data.errorCode} message={error.data.message} />
  }

  if (isFetchBaseQueryError(error) && typeof error.status === 'string') {
    return <Error {...rest} title={error.status} message={error.error} />
  }

  return (
    <Error
      {...rest}
      title="Unknown Error"
      message="Please try again and report to devs if the issue persists"
    />
  )
}

type ErrorProps = {
  className?: ClassValue
  title?: string
  message?: string
}

const Error: React.FC<ErrorProps> = ({ className, title, message }) => {
  return (
    <Result
      className={cn(className)}
      status="error"
      title={title}
      subTitle={message}
    />
  )
}